module.exports = __webpack_public_path__ + "static/ChefHero-fef1ce6bcf06aed5ef5b60ecbdcaa19e.jpg";